<template>
    <div class="tags">
      <router-link
        v-for="tag of list"
        :key="tag.id"
        :to="`${tag.id}`"
        class="tag_link"
      >
        {{tag.text}}
      </router-link>
    </div>

</template>
<script>
export default {
    name: 'AppTags',
    props: {
        list: Array,
    },
}
</script>
